import { useEffect, useState, type ComponentType } from 'react';
import { cn } from '@/lib/utils';
import { navIcon } from './sidebarNavStyles';

export function NavIcon({
  src,
  active,
  className,
}: {
  src: string;
  active: boolean;
  className?: string;
}) {
  return (
    <span
      aria-hidden
      className={cn(navIcon(active), className)}
      style={{
        maskImage: `url("${src}")`,
        WebkitMaskImage: `url("${src}")`,
        maskSize: 'contain',
        WebkitMaskSize: 'contain',
        maskRepeat: 'no-repeat',
        WebkitMaskRepeat: 'no-repeat',
        maskPosition: 'center',
        WebkitMaskPosition: 'center',
      }}
    />
  );
}

export function SubNavLogo({
  src,
  icon: Icon,
  iconClassName,
  className,
}: {
  src?: string;
  icon?: ComponentType<{ className?: string }>;
  iconClassName?: string;
  className?: string;
}) {
  const [failed, setFailed] = useState(false);
  useEffect(() => setFailed(false), [src]);

  const box = cn('inline-flex h-4 w-4 shrink-0 items-center justify-center', className);

  if (Icon) {
    return (
      <span aria-hidden className={box}>
        <Icon className={cn('h-4 w-4', iconClassName)} />
      </span>
    );
  }

  return (
    <span aria-hidden className={box}>
      {src && !failed && (
        <img
          src={src}
          alt=""
          draggable={false}
          decoding="async"
          onError={() => setFailed(true)}
          className="h-full w-full select-none object-contain"
        />
      )}
    </span>
  );
}
